import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";

/** Small mark next to a department head who may see the department's employee data. */
export default function HeadDataAccessBadge() {
  const { t } = useTranslation();
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-800"
      title={t("department_head_data_access")}
    >
      <ShieldCheck className="h-3 w-3" aria-hidden />
      {t("department_head_data_access_badge")}
    </span>
  );
}
